import { ArtBlocksChainId } from "contractConfig"

export const ART_BLOCKS_CHAIN_NAMES: Record<ArtBlocksChainId, string> = {
  1: "Ethereum",
  42161: "Arbitrum",
  8453: "Base",
}

const ART_BLOCKS_CHAIN_IDS = Object.keys(ART_BLOCKS_CHAIN_NAMES).map(Number) as ArtBlocksChainId[]

const BLOCK_EXPLORER_URLS: Record<ArtBlocksChainId, string> = {
  1: "https://etherscan.io",
  42161: "https://arbiscan.io",
  8453: "https://basescan.org",
}

const BLOCK_EXPLORER_NAMES: Record<ArtBlocksChainId, string> = {
  1: "Etherscan",
  42161: "Arbiscan",
  8453: "Basescan",
}

const OPENSEA_CHAIN_SLUGS: Record<ArtBlocksChainId, string> = {
  1: "ethereum",
  42161: "arbitrum",
  8453: "base",
}

interface TokenUrlParams {
  chainId: ArtBlocksChainId
  contractAddress: string
  tokenId: string
}

export const isArtBlocksChainId = (chainId?: number | string | null): chainId is ArtBlocksChainId => {
  const parsedChainId = Number(chainId)
  return ART_BLOCKS_CHAIN_IDS.includes(parsedChainId as ArtBlocksChainId)
}

export const normalizeContractAddress = (contractAddress: string) => contractAddress.toLowerCase()

export const getArtBlocksGeneratorUrl = ({ chainId, contractAddress, tokenId }: TokenUrlParams) =>
  `https://generator.artblocks.io/${chainId}/${normalizeContractAddress(contractAddress)}/${tokenId}`

export const getArtBlocksImageUrl = ({ chainId, contractAddress, tokenId }: TokenUrlParams) =>
  `https://media-proxy.artblocks.io/${chainId}/${normalizeContractAddress(contractAddress)}/${tokenId}.png`

export const getArtBlocksTokenUrl = ({ chainId, contractAddress, tokenId }: TokenUrlParams) =>
  `https://token.artblocks.io/${chainId}/${normalizeContractAddress(contractAddress)}/${tokenId}`

export const getBlockExplorerTokenUrl = ({ chainId, contractAddress, tokenId }: TokenUrlParams) =>
  `${BLOCK_EXPLORER_URLS[chainId]}/token/${normalizeContractAddress(contractAddress)}?a=${tokenId}`

export const getBlockExplorerTransactionUrl = ({
  chainId,
  transactionHash,
}: {
  chainId: ArtBlocksChainId
  transactionHash: string
}) =>
  `${BLOCK_EXPLORER_URLS[chainId]}/tx/${transactionHash}`

export const getBlockExplorerName = (chainId: ArtBlocksChainId) => BLOCK_EXPLORER_NAMES[chainId]

export const getOpenSeaAssetUrl = ({ chainId, contractAddress, tokenId }: TokenUrlParams) =>
  `https://opensea.io/assets/${OPENSEA_CHAIN_SLUGS[chainId]}/${normalizeContractAddress(contractAddress)}/${tokenId}`
